import React from 'react';
import Logo from '../Img/spinner-rosmo.gif';

function Loading() {
  return (
    <div style={{height:'100%', alignItems:'center', justifyContent:'space-evenly', display:'flex',}}>
        <img style={{width:'100px'}} src={Logo} alt="Rosmo Construcciones"/>
        <img style={{width:'100px'}} src={Logo} alt="Rosmo Construcciones"/>
        <img style={{width:'100px'}} src={Logo} alt="Rosmo Construcciones"/>
        <img style={{width:'100px'}} src={Logo} alt="Rosmo Construcciones"/>
    </div>
  )
}
export default Loading;
